/**
 * Unified input scaling — composes user sensitivity preferences with
 * the precision level into a single multiplier.
 *
 * Every input consumer (OrbitControls, MultiTouchHandler, applyCommandLive)
 * calls this instead of reading sensitivity values directly.
 *
 * BASE_INPUT_SCALE (½) is always applied — it tames the raw input to a
 * comfortable default. Precision mode multiplies on top of that, giving
 * ¼ or ⅛ effective scale for fine-grained control.
 */

/** Global baseline — halves raw input for a comfortable default feel. */
const BASE_INPUT_SCALE = 0.5;

export type InputScaleKind = "orbit" | "pan" | "dolly" | "gizmo";

export function getInputScale(
  kind: InputScaleKind,
  state: {
    orbitSensitivity: number;
    panSensitivity: number;
    dollySensitivity: number;
    precisionLevel: number;
  },
): number {
  // precisionLevel: 0 = off (1×), 0.5 = half, 0.25 = quarter — applied on top of base
  const precision = state.precisionLevel > 0 ? state.precisionLevel : 1;
  const scale = BASE_INPUT_SCALE * precision;
  switch (kind) {
    case "orbit":
      return state.orbitSensitivity * scale;
    case "pan":
      return state.panSensitivity * scale;
    case "dolly":
      return state.dollySensitivity * scale;
    case "gizmo":
      return scale;
  }
}
